/* eslint-disable no-inner-declarations */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useLayoutEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as htmlToImage from 'html-to-image';
import produce from 'immer';

// context
import StepperContext from '../../components/molecules/Stepper/StepperContext';
import LoaderContext from '../../components/molecules/Loader/LoaderContext';
// configs
import routes from '../../../application/config/routes';
// models
import uiModel from './uiModel';
// hooks
import { useModal } from '../../hooks/useModal';
import { useCurrentModal } from '../../hooks/useCurrentModal';
// components
import SummaryTemplate from '../../components/templates/SummaryTemplate/SummaryTemplate';
// const
import messagesInputAuthSms from '../../localData/messagesInputAuthSms';
// actions
import { otpActions } from '../../../application/actions/otp';
import { passwordActions } from '../../../application/actions/password';
// utils
import sendAnalitycs from '../../../domain/utils/utilitarios-frontend-coopeuch/Analytics';
import dataLayerObject from '../../../domain/utils/dataLayerObject';
import { toCurrencyFormat } from '../../../domain/utils/utilitarios-frontend-coopeuch/currency';
import { isArray } from '../../../domain/utils/utilitarios-frontend-coopeuch/array';
import { isMobile, getMobileOperatingSystem, getLinkStore, getMobileStore } from '../../utils/platform';
import { comesFromValidPreviousPath } from '../../utils/redirect';
import { generateDownloadDocument } from '../../../domain/utils/utilitarios-frontend-coopeuch/file';
import { rutEncryptedHash256 } from '../../../domain/utils/utilitarios-frontend-coopeuch/rut';

const isDeviceMobile = isMobile();

const idAppPassCoopeuch = {
  appCoopeuch: {
    iOS: 'appcoopeuch/id1520619303',
    android: 'com.coopeuchapp',
    harmonyOS: 'C105034677',
    windowsPhone: ''
  }, passCoopeuch: {
    iOS: 'passcoopeuch/id1524671704',
    android: 'cl.coopeuch.pass',
    harmonyOS: 'C103730561',
    windowsPhone: ''
  }
}

/* const nameMarketplaceBySystem = {
  iOS: 'App Store',
  android: 'Google Play',
  harmonyOS: 'App Gallery'
} */

// TODO: crear funcion que cree string tipe title from camelCase
const nameMarketplaceByStore = {
  appStore: 'App Store',
  googlePlay: 'Google Play',
  appGallery: 'App Gallery'
}

const Summary = () => {
  const [inputCodeSMS, setInputCodeSMS] = useState({ ...uiModel.inputCodeSMS });
  const [password, setPassword] = useState({ ...uiModel.password });
  // COMMENT: steps: initial, loading, input  ---  cases: 'available', 'timeExpired', 'incorretCode', 'locked'
  const [stateAuthSms, setStateAuthSms] = useState({
    step: 'initial',
    case: 'none',
  });
  const [storeSelected, setStoreSelected] = useState(''); // options: appstore, googleplay, appgallery.
  const [confirmationPassword, setConfirmationPassword] = useState({
    ...uiModel.confirmationPassword,
  });
  const [stateCreatingPassword, setStateCreatingPassword] = useState('otp'); // states: 'otp' / 'errorOtp / 'password' / 'errorPassword' / 'success'

  const [canValidateOtp /* , setCanValidateOtp */] = useState(false);
  const [canCreatePassword, setCanCreatePassword] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [confirmationPasswordVisibility, setConfirmationPasswordVisibility] = useState(false);

  const [detailData, setDetailData] = useState({});

  const appRoutes = routes();
  const history = useHistory();
  const dispatch = useDispatch();

  const { handleChangeStep } = useContext(StepperContext);

  const isLoadingFetchOtp = useSelector((store) => store.ui.loaders.isLoadingFetchOtp);
  const fetchOtp = useSelector((store) => store.entities.otp.fetchOtp);
  const validateOtp = useSelector((store) => store.entities.otp.validateOtp);
  const createPassword = useSelector((store) => store.entities.password.createPassword);
  const isLoadingValidateOtp = useSelector((store) => store.ui.loaders.isLoadingValidateOtp);
  const isLoadingCreatePassword = useSelector((store) => store.ui.loaders.isLoadingCreatePassword);

  const { handleChangeLoading } = useContext(LoaderContext);

  const [isOpenModalPaymentSuccess, openModalPaymentSuccess, closeModalPaymentSuccess] =
    useModal(false);
  const [isOpenModalVoucherDetail, openModalVoucherDetail, closeModalVoucherDetail] =
    useModal(false);
  const [
    isOpenModalUsabilityAndSatisfactionSurvey,
    setIsOpenModalUsabilityAndSatisfactionSurvey,
    closeModalUsabilityAndSatisfactionSurvey,
  ] = useModal(false);
  const [isOpenCurrentModal, nameCurrentModal, openCurrentModal, closeCurrentModal] =
    useCurrentModal(false);

  // const
  const email = sessionStorage.getItem('email') || '';
  const phone = sessionStorage.getItem('phone');
  const transactionDate = sessionStorage.getItem('transaction-date');
  const transactionDateTime = new Date(transactionDate);
  const optionsDateShort = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  };
  const optionsDateLong = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };
  const transactionDateTimeShort = transactionDateTime
    .toLocaleString('es-ES', optionsDateShort)
    .replaceAll('/', '-')
    .replace(',', '');
  const transactionDateTimeLong = `${transactionDateTime
    .toLocaleString('es-ES', optionsDateLong)
    .replace(',', '')} hrs`;
  const monthlyFees = sessionStorage.getItem('monthly-fees');
  const feeValue = sessionStorage.getItem('fee-value');
  const amountMonthlyFees = toCurrencyFormat(parseInt(monthlyFees, 10) * parseInt(feeValue, 10));
  const getDetailDataFromStorage = () => {
    const paymentType = sessionStorage.getItem('payment-type') || '';
    const authorizationCode = sessionStorage.getItem('authorization-code') || '';
    const lastDigitsCard = sessionStorage.getItem('last-digits-card') || '';

    return {
      tableFees: {
        body: [
          ['Pago primera inversión', `${amountMonthlyFees}`],
          ['Cuotas mensuales pactadas', `${monthlyFees}`],
          ['Próximo pago de cuotas', `Inicio de cada mes`],
        ],
        head: ['Cuotas de participación', ''],
      },
      tableAccount: {
        body: [
          ['Medio de pago', 'Webpay Plus'],
          ['Tipo de transacción', paymentType],
          ['Últimos 4 dígitos de la tarjeta', lastDigitsCard],
          ['Código de autorización', authorizationCode],
          ['Fecha de transacción', transactionDateTimeShort],
        ],
        head: ['Datos transacción', ''],
      },
    };
  };

  useLayoutEffect(() => {
    if (!comesFromValidPreviousPath(appRoutes, history.location)) {
      history.push(appRoutes.index.path);
    } else {
      const rut = sessionStorage.getItem('rut');
      async function sendUserIdToAnalitycs() {
        const userId = await rutEncryptedHash256(rut);
        sendAnalitycs(dataLayerObject.SUMMARY_LOADED, [
          {
            key: 'monto',
            param: 'valor-cuota',
            value: sessionStorage.getItem('fee-value') || '',
          },
          {
            key: 'cuotas',
            param: 'cantidad-cuotas',
            value: monthlyFees || '',
          },
          {
            key: 'userid',
            param: 'user-id',
            value: userId || '',
          },
        ]);
      }
      sendUserIdToAnalitycs();
    }
  }, []);

  useEffect(() => {
    handleChangeStep(3);
    window.scrollTo({ top: 0 });
    openModalPaymentSuccess();
    setDetailData({ ...getDetailDataFromStorage() });
  }, []);

  useEffect(() => {
    if (isDeviceMobile) {
      setStoreSelected(getMobileStore());
    }
  }, []);

  useEffect(() => {
    if (isLoadingFetchOtp === true) setStateAuthSms({ step: 'loading', case: 'none' });
    else if (fetchOtp?.success === true) {
      // TODO: revisar si es necesario validar fetchOtp con ?
      setStateAuthSms({ step: 'input', case: 'available' });
      resetInputCodeSMS();
    }
  }, [isLoadingFetchOtp]);

  useEffect(() => {
    if (!isLoadingValidateOtp) setTimeout(() => handleChangeLoading(isLoadingValidateOtp), 100);
    else handleChangeLoading(isLoadingValidateOtp);
  }, [isLoadingValidateOtp]);

  useEffect(() => {
    if (!isLoadingCreatePassword)
      setTimeout(() => handleChangeLoading(isLoadingCreatePassword), 100);
    else handleChangeLoading(isLoadingCreatePassword);
  }, [isLoadingCreatePassword]);

  useEffect(() => {
    if (fetchOtp.success === true) {
      setStateAuthSms({ step: 'input', case: 'available' });
    } else if (fetchOtp.error === true) {
      sendAnalitycs(dataLayerObject.BORDE_SIGNATURE_REQUEST_ERROR);
    }
  }, [fetchOtp]);

  useEffect(() => {
    if (validateOtp.success) {
      if (validateOtp.code === 200) setStateCreatingPassword('password');
      else if (validateOtp.code === 60) {
        // COMMENT: otp bloqueado
        setStateAuthSms({ step: 'input', case: 'locked' });
        const nextState = produce((draft) => {
          draft.value = ['', '', '', '', '', ''];
          draft.disabled = true;
        });
        setInputCodeSMS(nextState);
        sendAnalitycs(dataLayerObject.SUMMARY_SMS_LOCKED);
      } else if (validateOtp.code === 61) {
        // COMMENT: codigo expirado
        // TODO: ANALIZAR ESTE CASO, si bien el tiempo se controla en el front, hay un pequeño intervalo desde que llego el sms hasta validarlo donde puede expirarse
        console.log('CASO BORDE NO CONTROLADO');
      } else if (validateOtp.code === 62) {
        // COMMENT: codigo incorrecto
        const nextState = produce((draft) => {
          draft.value = ['', '', '', '', '', ''];
        });
        setInputCodeSMS(nextState);
        setStateAuthSms({ step: 'input', case: 'incorretCode' });
      }
    } else if (validateOtp.error === true) {
      setStateAuthSms({ step: 'input', case: 'retry' });
      const nextState = produce((draft) => {
        draft.value = ['', '', '', '', '', ''];
        draft.disabled = true;
      });
      setInputCodeSMS(nextState);
    }
  }, [validateOtp]);

  useEffect(() => {
    if (createPassword.success) {
      if (createPassword.code === 200) {
        setStateCreatingPassword('success');
        sessionStorage.setItem('password-already-created', 'SI')
        closeCurrentModal();
      }
    } else if (createPassword.error === true) {
      setStateCreatingPassword('errorPassword');
      sendAnalitycs(dataLayerObject.SUMMARY_CREATE_PASSWORD_ERROR);
    }
  }, [createPassword]);

  useEffect(() => {
    if (stateCreatingPassword === 'otp') {
      const isValidInputSMS = inputCodeSMS.isValid(inputCodeSMS.value, inputCodeSMS.disabled);
      if (isValidInputSMS) handleValidateOtp();
    } else if (stateCreatingPassword === 'password') {
      const isValidPassword = password.isValid(
        password.value,
        password.validations
      );
      const isValidConfirmationPassword = password.value === confirmationPassword.value;
      setCanCreatePassword(isValidPassword && isValidConfirmationPassword);
    }
  }, [password, confirmationPassword, inputCodeSMS]);

  const handleDownloadComponentImage = (idComponent, componentName) => {
    htmlToImage.toJpeg(document.getElementById(idComponent), { quality: 0.75 }).then((dataUrl) => {
      generateDownloadDocument(`${componentName}.jpeg`, dataUrl, 'image/jpeg');
    });
  };

  const handleCloseModalPaymentSuccess = () => {
    sendAnalitycs(dataLayerObject.SUMMARY_CLOSE_MODAL_SUCCESSFULL);
    closeModalPaymentSuccess();
  };

  const handleOpenModalVoucherDetail = () => {
    sendAnalitycs(dataLayerObject.SUMMARY_SHOW_DETAILS);
    openModalVoucherDetail();
  };
  const handleReturnMainPage = () => {
    sendAnalitycs(dataLayerObject.SUMMARY_BACK_TO_COOPEUCH);
    sessionStorage.clear();
    window.location = appRoutes.landing.path;
  };

  const handleCallsurvey = () => {
    sendAnalitycs(dataLayerObject.SURVEY_USABILITY_SATISFACTION_LOAD);
    setIsOpenModalUsabilityAndSatisfactionSurvey(true);
  };

  const handleChangeField = ({ field, property, value, extra }) => {
    const stateMap = {
      inputCodeSMS: { state: inputCodeSMS, seter: setInputCodeSMS },
      password: { state: password, seter: setPassword },
      confirmationPassword: { state: confirmationPassword, seter: setConfirmationPassword },
    };

    const generateErrorsList = () => {
      const errors = [];
      const isValidValue = isArray(stateMap[field])
        ? stateMap[field][extra.index].isValid(value)
        : stateMap[field].state.isValid(value);

      if (!isValidValue) errors.push({ text: 'El formato ingresado es incorrecto', type: 'error' });
      else if (
        stateMap[field].state.complement &&
        stateMap[stateMap[field].state.complement].state.value !== '' &&
        value !== stateMap[stateMap[field].state.complement].state.value
      )
        if (field === 'confirmationPassword')
          errors.push({ text: 'las contraseñas no coinciden', type: 'error' });
      return errors;
    };

    const errorsList = property === 'value' ? generateErrorsList() : [];

    const nextState = produce((draft) => {
      if (isArray(stateMap[field].state)) {
        draft[extra.index][property] = value;
        draft[extra.index].errors = errorsList;
      } else {
        draft[property] = value;
        draft.errors = errorsList;
      }
    });
    stateMap[field].seter(nextState);
  };

  const handleChangePasswordVisibility = (entity) => {
    if (entity === 'password') setPasswordVisibility((prevState) => !prevState);
    else setConfirmationPasswordVisibility((prevState) => !prevState);
  };

  const resetInputCodeSMS = (disabled = false) => {
    handleChangeField({
      field: 'inputCodeSMS',
      property: 'value',
      value: ['', '', '', '', '', ''],
    });
    handleChangeField({
      field: 'inputCodeSMS',
      property: 'disabled',
      value: disabled,
    });
  };

  const handleValidateOtp = () => {
    // sendAnalitycs(dataLayerObject.SUMMARY_VALIDATE_SMS);
    const payloadValidateOtp = {
      code: inputCodeSMS.value.join(''),
    };
    dispatch(otpActions.validateOtp(payloadValidateOtp));
  };

  const handleCreatePassword = () => {
    sendAnalitycs(dataLayerObject.SUMMARY_CREATE_PASSWORD);
    const payloadCreatePassword = {
      password: password.value,
    };
    dispatch(passwordActions.createPassword(payloadCreatePassword));
  };

  const handleInvokeAuthSms = () => {
    sendAnalitycs(dataLayerObject.SUMMARY_REQUESTS_SMS);
    // if (fetchOtp.error) showModal(false);
    dispatch(otpActions.fetchOtp());
  };

  const handleTimeOverToRespond = () => {
    setStateAuthSms({ step: 'input', case: 'timeExpired' });
    resetInputCodeSMS(true);
  };

  const handleChangeStoreSelected = (opt) => {
    setStoreSelected(opt)
    sendAnalitycs(dataLayerObject.SUMMARY_SELECT_STORE, [
      {
        key: 'eve-lab',
        param: 'texto-boton',
        value: nameMarketplaceByStore[opt]
      }
    ]);
  }

  const handleClickButtonGallery = (systemName, nameApp) => {
    const url = getLinkStore(idAppPassCoopeuch[nameApp][systemName], systemName)
    window.location = url;
    // window.open(url);
  }

  const handleOpenCurrentModal = (nameModal) => {
    const buttonsText = {
      password: "Crear clave",
      appCoopeuch: "Descargar AppCoopeuch",
      passCoopeuch : "Descargar PassCoopeuch"
    }
    sendAnalitycs(dataLayerObject.SUMMARY_CLIK_OPTION_DIGITIZE, [
      {
        key: 'eve-lab',
        param: 'texto-boton',
        value: buttonsText[nameModal]
      }
    ]);
    if (nameModal !== 'password' && isDeviceMobile) {
      // COMMENT: Cuando estamos en version mobile, no es necesario abril el modal, solo redirijimos a la store del dispositivo
      handleClickButtonGallery(getMobileOperatingSystem(), nameModal)
    } else {
      openCurrentModal(nameModal);
    }
    // COMMENT: reseteamos la tienda seleccionada anteriormente para limpiar el radio button
    if (storeSelected !== '') setStoreSelected('')
  };

  const handleCloseCurrentModal = () => {
    if (nameCurrentModal === 'password') {
      setStateCreatingPassword('otp');
      setStateAuthSms({
        step: 'initial',
        case: 'none',
      });
      setInputCodeSMS({ ...uiModel.inputCodeSMS });
      setPassword({ ...uiModel.password });
      setConfirmationPassword({ ...uiModel.password });
    }
    closeCurrentModal();
  }

  const handleRedirectToPrivateSite = () => {
    window.location = appRoutes.privateSite.path;
    // TODO: ver si es posible eliminar el historial de navegacion para que cuando se vaya al sitio privado no se permita retroceder a este flujo
  };

  return (
    <SummaryTemplate
      detailData={detailData}
      email={email}
      monthlyFees={monthlyFees}
      amountMonthlyFees={amountMonthlyFees}
      transactionDate={transactionDate}
      transactionDateTimeLong={transactionDateTimeLong}
      transactionDateTimeShort={transactionDateTimeShort}
      isMobileDevice={isDeviceMobile}
      isOpenModalPaymentSuccess={isOpenModalPaymentSuccess}
      isOpenModalVoucherDetail={isOpenModalVoucherDetail}
      isOpenModalUsabilityAndSatisfactionSurvey={isOpenModalUsabilityAndSatisfactionSurvey}
      closeModalUsabilityAndSatisfactionSurvey={closeModalUsabilityAndSatisfactionSurvey}
      openModalVoucherDetail={handleOpenModalVoucherDetail}
      closeModalVoucherDetail={closeModalVoucherDetail}
      closeModalPaymentSuccess={handleCloseModalPaymentSuccess}
      onDownloadComponentPdf={handleDownloadComponentImage}
      onReturnMainPage={handleReturnMainPage}
      onCallSurvey={handleCallsurvey}
      phone={phone}
      // Creation Password
      storeSelected={storeSelected}
      inputCodeSMS={inputCodeSMS}
      password={password}
      confirmationPassword={confirmationPassword}
      passwordVisibility={passwordVisibility}
      confirmationPasswordVisibility={confirmationPasswordVisibility}
      stateAuthSms={stateAuthSms}
      stateCreatingPassword={stateCreatingPassword}
      canCreatePassword={canCreatePassword}
      canValidateOtp={canValidateOtp}
      messagesInputAuthSms={messagesInputAuthSms}
      onChangePasswordVisibility={handleChangePasswordVisibility}
      onInvokeAuthSms={handleInvokeAuthSms}
      onChangeEletronicSignature={handleChangeField}
      onChangeStoreSelected={handleChangeStoreSelected}
      onTimeOverToRespond={handleTimeOverToRespond}
      onValidateOtp={handleValidateOtp}
      onCreatePassword={handleCreatePassword}
      isOpenCurrentModal={isOpenCurrentModal}
      nameCurrentModal={nameCurrentModal}
      onCloseCurrentModal={handleCloseCurrentModal}
      onOpenCurrentModal={handleOpenCurrentModal}
      onRedirectToPrivateSite={handleRedirectToPrivateSite}
    />
  );
};

export default Summary;
